import React, { useMemo } from "react";

import NoResultCard from "components/noResultCard";
import WeAreSorryCard from "components/weAreSorry";
import useCollapsible from "hooks/useCollapsible";
import CollapsibleArrow from "components/collapsibleArrow";
import { API_FETCH_STATUS } from "constants/common";

import Loader from "../loader/loader";
import PartyListContainer from "../partiesListContainer/partiesListContainer";

import styles from "./accordionView.scss";

const { user_name, accordian_view, accordion_view_items, accordion_view_header } = styles;
const { LOADING, ERROR } = API_FETCH_STATUS;
const AccordionView = ({
  lob,
  product,
  lobDisplayName,
  selectedParty,
  partyAggregationLevel,
  setSelectedParty,
  partySelectorState,
  setPartySelectorState,
  viewMode
}) => {
  const { userPartyData, state, searchValue } = partySelectorState;

  const Ids = useMemo(() => userPartyData?.map(({ emailId }) => emailId), [userPartyData]);
  const { toggleById, isExpanded } = useCollapsible({
    Ids,
    expandAllByDefault: !!searchValue.length,
  });

  if (state === LOADING) {
    return <Loader />;
  }

  if (state === ERROR) {
    return <WeAreSorryCard buttonDisplayName="Clear Filters" onButtonClick={() => setPartySelectorState({ searchValue: "" })} />;
  }

  return userPartyData?.length ? (
    <div className={accordian_view}>
      <ul className={accordion_view_items}>
        {userPartyData.map((user, index) => (
          <li key={user.emailId}>
            <div className={accordion_view_header} key={user.emailId} onClick={() => toggleById(user.emailId, true)}>
              <div className={user_name}>
                {`${user.name} ( ${searchValue.length ? user.totalFilterCount : user.totalCount} Accounts )`}
              </div>
              <CollapsibleArrow direction={isExpanded(user.emailId) ? "down" : "up"} />
            </div>
            {isExpanded(user.emailId) && (
              <PartyListContainer
                {...{
                  lob,
                  product,
                  lobDisplayName,
                  selectedParty,
                  partyAggregationLevel,
                  setSelectedParty,
                  partySelectorState,
                  setPartySelectorState,
                  userPartyData: userPartyData?.[index],
                  viewMode
                }}
              />
            )}
          </li>
        ))}
      </ul>
    </div>
  ) : (
    <NoResultCard />
  );
};

export default AccordionView;
